import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.69231 3.80526C9.69231 3.97141 9.63231 4.11403 9.51231 4.2331L6.42646 7.29495C6.31615 7.41126 6.174 7.46895 6.00046 7.46895C5.82969 7.46895 5.68569 7.41126 5.56892 7.29495L2.48308 4.2331C2.36631 4.11079 2.30769 3.96818 2.30769 3.80526C2.30769 3.6451 2.36631 3.50387 2.48308 3.38156L2.83892 3.02895C2.95892 2.90987 3.10246 2.85033 3.27 2.85033C3.43754 2.85033 3.58108 2.90987 3.70154 3.02895L5.09031 4.4071V1.09603C5.09031 0.932641 5.14938 0.800641 5.26754 0.698179C5.38615 0.596641 5.52969 0.54541 5.69677 0.54541H6.30323C6.47077 0.54541 6.61385 0.596641 6.73246 0.698179C6.85062 0.800641 6.91015 0.932641 6.91015 1.09603V4.4071L8.30354 3.02895C8.41708 2.90987 8.55969 2.85033 8.73 2.85033C8.90077 2.85033 9.04292 2.90987 9.15646 3.02895L9.51231 3.38156C9.63231 3.5011 9.69231 3.64187 9.69231 3.80526Z",
			fill: "#0578BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.84615 9.3151H10.1538V7.46895C10.1538 7.21418 10.3606 7.00741 10.6154 7.00741H11.5385C11.7932 7.00741 12 7.21418 12 7.46895V10.6997C12 10.9545 11.7932 11.1613 11.5385 11.1613H0.461538C0.206769 11.1613 0 10.9545 0 10.6997V7.46895C0 7.21418 0.206769 7.00741 0.461538 7.00741H1.38462C1.63938 7.00741 1.84615 7.21418 1.84615 7.46895V9.3151Z",
			fill: "#0578BE"
		})
	]
});
const ForwardRef = forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
